import React, { useEffect, useState } from "react";
import api from "../lib/api";
import TVEpisodeCard from "../components/TVEpisodeCard";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../components/ui/carousel";
import { Play, Tv } from "lucide-react";

export default function TV() {
  const [episodes, setEpisodes] = useState([]);
  useEffect(() => {
    api.get("/tv/episodes").then((r) => setEpisodes(r.data || []));
  }, []);

  const featured = episodes.find((e) => e.featured) || episodes[0];
  const rest = episodes.filter((e) => e.id !== featured?.id);
  const seasons = Array.from(new Set(episodes.map((e) => e.season || 1))).sort();

  return (
    <div data-testid="tv-page" className="bg-[#080808] text-white min-h-screen">
      {/* HERO */}
      <section className="relative h-[70vh] min-h-[480px] overflow-hidden">
        <img src={`${process.env.REACT_APP_BACKEND_URL}/api/static/heroes/tv_hero.png`} alt="" className="absolute inset-0 w-full h-full object-cover animate-ken-burns" />
        {featured && <img src={featured.thumbnail} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-overlay" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent" />
        <div className="relative container-xl h-full flex flex-col justify-end pb-12 md:pb-16">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.4em] text-[#C9A961] mb-4">
            <Tv className="h-4 w-4" /> Amazonico TV · Season 1
          </div>
          <h1 className="editorial-heading text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-[0.9] max-w-4xl">
            Il vino <span className="italic text-[#C9A961]">si racconta.</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl">
            Reportage esclusivi dentro le cantine più iconiche del mondo. Produttori, terroir, vendemmie, storie familiari.
            Nuovo episodio ogni due settimane.
          </p>
          {featured && (
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href={`/tv/${featured.id}`} data-testid="tv-hero-play" className="inline-flex items-center gap-3 px-7 py-4 bg-[#C9A961] text-black font-semibold uppercase tracking-[0.2em] text-xs hover:bg-white transition-colors">
                <Play className="h-4 w-4 fill-current" /> Guarda: {featured.title.split(" · ")[0]}
              </a>
              <a href="/media-kit" data-testid="tv-hero-mediakit" className="inline-flex items-center gap-2 px-6 py-4 bg-white/5 border border-white/30 text-white uppercase tracking-[0.2em] text-xs hover:bg-white hover:text-black transition-colors">
                Pacchetti per brand →
              </a>
              <div className="text-xs uppercase tracking-[0.3em] text-white/60">{episodes.length} episodi disponibili</div>
            </div>
          )}
        </div>
      </section>

      {/* EPISODE CAROUSEL */}
      {episodes.length > 0 && (
        <section className="py-14 md:py-20 border-t border-white/10">
          <div className="container-xl mb-8 flex items-end justify-between gap-4">
            <div>
              <div className="text-xs uppercase tracking-[0.4em] text-[#C9A961] mb-2">Stagione 1</div>
              <h2 className="editorial-heading text-3xl md:text-4xl">Tutti gli episodi</h2>
            </div>
            <div className="text-sm text-white/50">{episodes.length} episodi</div>
          </div>
          <div className="container-xl">
            <Carousel opts={{ align: "start", loop: false }} className="w-full">
              <CarouselContent className="-ml-4">
                {episodes.map((ep) => (
                  <CarouselItem key={ep.id} className="pl-4 basis-[80%] sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
                    <TVEpisodeCard ep={ep} />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="hidden md:flex bg-black/70 border-white/20 text-white hover:bg-white hover:text-black" />
              <CarouselNext className="hidden md:flex bg-black/70 border-white/20 text-white hover:bg-white hover:text-black" />
            </Carousel>
          </div>
        </section>
      )}
    </div>
  );
}
